export const templateReplace = (
  content: string,
  varName: string,
  newContent: string
): string => {
  return content.replaceAll(`{${varName}}`, newContent);
};
